import React, { useEffect } from "react";
import PropTypes from "prop-types";
import "flatpickr/dist/themes/material_blue.css";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { MetaTags } from "react-meta-tags";
import {
  addAppById,
  getAppData,
  setAppDataNull,
} from "../../../store/apps/actions";
import { Container } from "reactstrap";
import Breadcrumbs from "../../../components/Common/Breadcrumb";
import ApplicationForm from "../../../components/forms/ApplicationForm";
import { getTrackerPlatforms } from "../../../store/meta/actions";
import ModifiedMetaTags from '../../../components/ModifiedMetaTags/index';

const AddApplication = props => {
  const client_id = props.match.params.clientId;

  useEffect(() => {
    props.getTrackerPlatforms();

    return () => {
      props.setAppDataNull();
    };
  }, []);

  const onSubmitForm = data => {
    props.addAppById(data.client_id, data);
    props.history.push(`/clients/${client_id}/#settings`);
  };

  return (
    <React.Fragment>
      <div className="page-content">
      <ModifiedMetaTags title="Add application | Mobihunter" />

        <Container fluid>
          <Breadcrumbs
            title="Client"
            breadcrumbItem={"Add application"}
            link={`/clients/${props.match.params.clientId}/#settings`}
          />

          <ApplicationForm
            onSubmitForm={onSubmitForm}
            app_data={props.app_data}
            tracking_platforms={props.tracking_platforms}
          />
        </Container>
      </div>
    </React.Fragment>
  );
};

AddApplication.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      clientId: PropTypes.node,
    }).isRequired,
  }).isRequired,
  history: PropTypes.object.isRequired,
  getAppData: PropTypes.func.isRequired,
  setAppDataNull: PropTypes.func.isRequired,
  app_data: PropTypes.any,
  loading: PropTypes.bool,
  addAppById: PropTypes.func.isRequired,
  getTrackerPlatforms: PropTypes.func.isRequired,
  tracking_platforms: PropTypes.any,
};

const mapStateToProps = state => ({
  app_data: state.Apps.app_data,
  loading: state.Apps.loading,
  tracking_platforms: state.Meta.tracking_platforms,
});

export default connect(mapStateToProps, {
  getAppData,
  setAppDataNull,
  addAppById,
  getTrackerPlatforms,
})(withRouter(AddApplication));
